<h2 class="page-title">Commissions</h2>
<div class="commissions-container">
  <div class="tab-bar-row">
    <div class="tabs-scroll">
      @for (template of templates; track template.id; let i = $index) {
        <div class="tab-chip"
             [class.active]="activeTemplateIndex === i"
             (click)="selectTemplate(i)">
          <span class="tab-name">{{ template.name }}</span>
          @if (activeTemplateIndex === i) {
            <mat-icon class="tab-menu-icon" [matMenuTriggerFor]="customTemplateMenu">more_vert</mat-icon>
          }
        </div>
      }
      <div class="scroll-arrow" (click)="scrollTabs()">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </div>
    <button class="add-tab-btn" (click)="openCreateDialog()">
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <mat-menu #templateMenu="matMenu">
    <button mat-menu-item (click)="enableEditMode()">Edit</button>
    <button mat-menu-item (click)="editTemplateName()">Rename</button>
  </mat-menu>

  <mat-menu #customTemplateMenu="matMenu">
    <button mat-menu-item (click)="enableEditMode()">Edit</button>
    <button mat-menu-item (click)="editTemplateName()">Rename</button>
    <button mat-menu-item class="delete-menu-item"
            [disabled]="!canDelete()"
            (click)="canDelete() && deleteTemplate()">Delete</button>
  </mat-menu>

  @if (activeTemplate && form) {
    <form [formGroup]="form" class="commission-form">

      <div class="card-assignment-section">
        <mat-select [(value)]="selectedCardIds" multiple
                    [disabled]="!editMode"
                    panelClass="card-select-panel"
                    placeholder="Assign to User Cards"
                    (selectionChange)="assignCards()"
                    (openedChange)="onDropdownOpenChanged($event)">
          <div class="card-search-wrapper"
               (click)="$event.stopPropagation()"
               (mousedown)="$event.stopPropagation()">
            <input class="card-search-input"
                   type="text"
                   placeholder="Search by username..."
                   [value]="cardSearchQuery"
                   (input)="onCardSearch($event)"
                   (keydown)="$event.stopPropagation()"
                   autocomplete="off">
          </div>
          <mat-option [value]="-1" (click)="toggleAllCards()">All</mat-option>
          @for (card of getFilteredCardsForDropdown(); track card.userCardId) {
            <mat-option [value]="card.userCardId" [class.available-card-option]="isCardAvailable(card)">
              {{ card.qrUsername || card.cardId }}
            </mat-option>
          }
        </mat-select>
      </div>

      <div class="global-commission-row" [formGroup]="form">
        <div class="global-group">
          <mat-checkbox formControlName="applyToAllStandard">
            Commission for all standards
          </mat-checkbox>
          <div class="filled-input-group" [class.field-disabled]="!applyToAllStandard">
            <input type="number" formControlName="globalStandardValue"
                   class="filled-input" min="0"
                   [max]="getMaxValue(form.get('globalStandardUnit')?.value)"
                   [attr.readonly]="!applyToAllStandard ? '' : null">
            <span class="filled-divider"></span>
            <div class="select-with-icon-wrapper">
              <select formControlName="globalStandardUnit" class="filled-select"
                      [class.hide-percent-text]="form.get('globalStandardUnit')?.value === '%'"
                      [class.show-currency]="form.get('globalStandardUnit')?.value === 'AMD'"
                      [attr.disabled]="!applyToAllStandard ? '' : null">
                <option value="%">%</option>
                <option value="AMD">֏</option>
              </select>
              @if (form.get('globalStandardUnit')?.value === '%') {
                <img src="assets/svg/percent.svg" alt="%" class="select-percent-icon">
              }
              @if (form.get('globalStandardUnit')?.value === 'AMD') {
                <span class="currency-symbol">֏</span>
              }
              <img src="assets/svg/arrow_drop_down.svg" alt="dropdown" class="select-arrow-icon">
            </div>
          </div>
        </div>

        <div class="global-group">
          <mat-checkbox formControlName="applyToAllExtra">
            Extra commission for all extra
          </mat-checkbox>
          <div class="filled-input-group" [class.field-disabled]="!applyToAllExtra">
            <input type="number" formControlName="globalExtraValue"
                   class="filled-input" min="0"
                   [max]="getMaxValue(form.get('globalExtraUnit')?.value)"
                   [attr.readonly]="!applyToAllExtra ? '' : null">
            <span class="filled-divider"></span>
            <div class="select-with-icon-wrapper">
              <select formControlName="globalExtraUnit" class="filled-select"
                      [class.hide-percent-text]="form.get('globalExtraUnit')?.value === '%'"
                      [class.show-currency]="form.get('globalExtraUnit')?.value === 'AMD'"
                      [attr.disabled]="!applyToAllExtra ? '' : null">
                <option value="%">%</option>
                <option value="AMD">֏</option>
              </select>
              @if (form.get('globalExtraUnit')?.value === '%') {
                <img src="assets/svg/percent.svg" alt="%" class="select-percent-icon">
              }
              @if (form.get('globalExtraUnit')?.value === 'AMD') {
                <span class="currency-symbol">֏</span>
              }
              <img src="assets/svg/arrow_drop_down.svg" alt="dropdown" class="select-arrow-icon">
            </div>
          </div>
        </div>
      </div>

      <div class="methods-section" formArrayName="methods">
          <div class="methods-grid">
            <div class="methods-col">
              <div class="methods-col-header" [style.grid-template-columns]="methodRowColumns">
                <div class="col-spacer"></div>
                <span class="col-label">Standard <span class="label-role">(Sender)</span></span>
                <span class="col-label">Extra <span class="label-role">(Receiver)</span></span>
              </div>
              @for (method of methodsArray.controls; track method; let i = $index) {
                @if (i % 2 === 0) {
                  <div class="method-row" [formGroupName]="i"
                       [style.grid-template-columns]="methodRowColumns">
                    <div class="method-brand">
                      <img [src]="getMethodInfo(i).logoUrl" [alt]="getMethodInfo(i).name"
                           class="method-logo" (error)="onImageError($event)">
                    </div>
                    <div class="filled-input-group compact" [class.field-disabled]="applyToAllStandard">
                      <input type="number" formControlName="standardValue"
                             class="filled-input" min="0"
                             [max]="getMaxValue(method.get('standardUnit')?.value)"
                             [attr.readonly]="applyToAllStandard ? '' : null">
                      <span class="filled-divider"></span>
                      <div class="select-with-icon-wrapper">
                        <select formControlName="standardUnit" class="filled-select"
                                [class.hide-percent-text]="method.get('standardUnit')?.value === '%'"
                                [class.show-currency]="method.get('standardUnit')?.value === 'AMD'">
                          <option value="%">%</option>
                          <option value="AMD">֏</option>
                        </select>
                        @if (method.get('standardUnit')?.value === '%') {
                          <img src="assets/svg/percent.svg" alt="%" class="select-percent-icon">
                        }
                        @if (method.get('standardUnit')?.value === 'AMD') {
                          <span class="currency-symbol">֏</span>
                        }
                        <img src="assets/svg/arrow_drop_down.svg" alt="dropdown" class="select-arrow-icon">
                      </div>
                    </div>
                    <div class="filled-input-group compact" [class.field-disabled]="applyToAllExtra">
                      <input type="number" formControlName="extraValue"
                             class="filled-input" min="0"
                             [max]="getMaxValue(method.get('extraUnit')?.value)"
                             [attr.readonly]="applyToAllExtra ? '' : null">
                      <span class="filled-divider"></span>
                      <div class="select-with-icon-wrapper">
                        <select formControlName="extraUnit" class="filled-select"
                                [class.hide-percent-text]="method.get('extraUnit')?.value === '%'"
                                [class.show-currency]="method.get('extraUnit')?.value === 'AMD'">
                          <option value="%">%</option>
                          <option value="AMD">֏</option>
                        </select>
                        @if (method.get('extraUnit')?.value === '%') {
                          <img src="assets/svg/percent.svg" alt="%" class="select-percent-icon">
                        }
                        @if (method.get('extraUnit')?.value === 'AMD') {
                          <span class="currency-symbol">֏</span>
                        }
                        <img src="assets/svg/arrow_drop_down.svg" alt="dropdown" class="select-arrow-icon">
                      </div>
                    </div>
                  </div>
                }
              }
            </div>

            <div class="methods-col">
              <div class="methods-col-header" [style.grid-template-columns]="methodRowColumns">
                <div class="col-spacer"></div>
                <span class="col-label">Standard <span class="label-role">(Sender)</span></span>
                <span class="col-label">Extra <span class="label-role">(Receiver)</span></span>
              </div>
              @for (method of methodsArray.controls; track method; let i = $index) {
                @if (i % 2 === 1) {
                  <div class="method-row" [formGroupName]="i"
                       [style.grid-template-columns]="methodRowColumns">
                    <div class="method-brand">
                      <img [src]="getMethodInfo(i).logoUrl" [alt]="getMethodInfo(i).name"
                           class="method-logo" (error)="onImageError($event)">
                    </div>
                    <div class="filled-input-group compact" [class.field-disabled]="applyToAllStandard">
                      <input type="number" formControlName="standardValue"
                             class="filled-input" min="0"
                             [max]="getMaxValue(method.get('standardUnit')?.value)"
                             [attr.readonly]="applyToAllStandard ? '' : null">
                      <span class="filled-divider"></span>
                      <div class="select-with-icon-wrapper">
                        <select formControlName="standardUnit" class="filled-select"
                                [class.hide-percent-text]="method.get('standardUnit')?.value === '%'"
                                [class.show-currency]="method.get('standardUnit')?.value === 'AMD'">
                          <option value="%">%</option>
                          <option value="AMD">֏</option>
                        </select>
                        @if (method.get('standardUnit')?.value === '%') {
                          <img src="assets/svg/percent.svg" alt="%" class="select-percent-icon">
                        }
                        @if (method.get('standardUnit')?.value === 'AMD') {
                          <span class="currency-symbol">֏</span>
                        }
                        <img src="assets/svg/arrow_drop_down.svg" alt="dropdown" class="select-arrow-icon">
                      </div>
                    </div>
                    <div class="filled-input-group compact" [class.field-disabled]="applyToAllExtra">
                      <input type="number" formControlName="extraValue"
                             class="filled-input" min="0"
                             [max]="getMaxValue(method.get('extraUnit')?.value)"
                             [attr.readonly]="applyToAllExtra ? '' : null">
                      <span class="filled-divider"></span>
                      <div class="select-with-icon-wrapper">
                        <select formControlName="extraUnit" class="filled-select"
                                [class.hide-percent-text]="method.get('extraUnit')?.value === '%'"
                                [class.show-currency]="method.get('extraUnit')?.value === 'AMD'">
                          <option value="%">%</option>
                          <option value="AMD">֏</option>
                        </select>
                        @if (method.get('extraUnit')?.value === '%') {
                          <img src="assets/svg/percent.svg" alt="%" class="select-percent-icon">
                        }
                        @if (method.get('extraUnit')?.value === 'AMD') {
                          <span class="currency-symbol">֏</span>
                        }
                        <img src="assets/svg/arrow_drop_down.svg" alt="dropdown" class="select-arrow-icon">
                      </div>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        </div>

      @if (editMode) {
        <div class="form-actions">
          <button type="button" class="btn-cancel" (click)="cancel()">Cancel</button>
          <button type="button" class="btn-save" [disabled]="saving" (click)="save()">Save</button>
        </div>
      }
    </form>
  }

  @if (loading) {
    <div class="loading-spinner">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }
</div>
